import { AutoComplete, Input } from 'antd';
import Axios from 'axios';
import React, { useState } from 'react';


import { getAjaxUrl } from '../../../lib/helpers';
import './autosuggest.css';

var timeout;

function debounce(func, wait, immediate) {

  return function executedFunction() {
    var context = this;
    var args = arguments;
	    
    var later = function() {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };

    var callNow = immediate && !timeout;
	
    clearTimeout(timeout);

    timeout = setTimeout(later, wait);
	
    if (callNow) func.apply(context, args);
  };
};

const AutoSuggestInput = (props) => {
  const [options, setOptions] = useState([]);
  const [isSearching, setIsSearching] = useState(false);

  const onSearch = (searchText) => {
    if (!searchText) {
      return;
    }

    setIsSearching(true);
    Axios.get(getAjaxUrl() + `?action=mnt_get_suggestion&filter=${props.field}&str=${searchText}`).then((res) => {
      let data = [];
      const recommendations = [
        'Upper Deck',
        'Pokemon TCG',
        'Panini',
        'Series One',
      ];

      if (res.data.res.length) {
        data = res.data.res.map((item) => {
          const isRecommended = recommendations.includes(item.meta_value.trim()) ? 'suggestion-recommendation' : '';
          return {
            value: item.meta_value,
            label: (
              <>
                {isRecommended && (
                  <>
                    <strong>Recommended:</strong>
                    <br></br>
                  </>
                )}
                <span className={isRecommended}>{item.meta_value}</span>
              </>
            )
          };
        });
      }

      console.log(data);
      if (props.field === 'company') {
        
      }

      setOptions(data);
      setIsSearching(false);
    }).catch((err) => {
      setIsSearching(false);
    });
  };
  
  const onSelect = (data) => {
    props.setValue(data);
  };
  
  const onChange = (data) => {
    props.setValue(data);
  };

  return (
    <AutoComplete
      loading={isSearching}
      value={props.value}
      options={options}
      onSelect={onSelect}
      onSearch={debounce(onSearch, 300)}
      onChange={onChange}
      placeholder={props.placeholder}
    >
      <Input />
    </AutoComplete>
  );
};

export default AutoSuggestInput;